import { FC, useMemo } from 'react'
import { FilterCriteriaValueFieldProps } from './FilterCriteriaValueFieldProps'
import { useSelectSingleMulti } from './useSelectSingleMulti'
import { Autocomplete, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const FilterCriteriaValueYesNo: FC<FilterCriteriaValueFieldProps> = ({
  operator,
  fieldProps: { value, onChange, error, ...fieldProps },
}) => {
  const { t } = useTranslation()

  const { calculatedValue, handleChange, multiple } = useSelectSingleMulti({
    value,
    onChange,
    operator,
  })

  const options = useMemo<Array<string>>(() => [t('yes'), t('no')], [t])

  return (
    <Autocomplete
      multiple={multiple}
      renderInput={(params) => <TextField variant="outlined" error={error} {...params} />}
      options={options}
      onChange={handleChange}
      value={calculatedValue}
      slotProps={{ chip: { size: 'small' } }}
      {...fieldProps}
    />
  )
}
